module.exports = "/video-roulette/img/yellow-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/yellow-ball.png
// module id = 2442
// module chunks = 10